
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className = '', hover = false }) => {
  return (
    <div
      className={`bg-white rounded-xl shadow-lg p-6 ${
        hover ? 'hover:shadow-2xl hover:-translate-y-2 transition-all duration-300' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
};
